import { appstr } from "../utils/appstr";
import { appstrp } from "../utils/appstrp";
import { doUnzip } from "../utils/doUnzip";
import {
  enumBGOption,
  enumChartOpenModes,
  enumDateTimeDisplayOptions,
  enumFileFilterMode,
  enumFileMgrMode,
  enumFolderStatus,
  enumFolderType,
  enumKeyboardTargetEnterAction,
  enumSaveScope,
  kBackgroundExtensions,
  kChartDocExtensions,
  kFlatFileList,
  kROUser,
  kRWUser,
  kAdminUser,
  kSpecialFolders
} from "../constants";
import { IsOrgChartFile } from "../utils/IsOrgChartFile";
import { QAlert } from "./QAlert";
import { QDirRFCJSON } from "./QDirRFCJSON";
import { QFileRFC } from "./QFileRFC";
import { QFolder } from "./QFolder";
import { qfolderobj } from "../utils/qfolderobj";
import { Globals } from "./Globals";
import { ApplyAccessGroup } from "../utils/ApplyAccessGroup";
import { GetExtension } from "../utils/GetExtension";
import { IsHiddenFolder } from "../utils/IsHiddenFolder";
import { StripExtension } from "../utils/StripExtension";
import { IsBackgroundFile } from "../utils/IsBackgroundFile";
import { ValidateRename } from "../utils/ValidateRename";

export class QFileMgr {
  constructor() {
    this.fFolderList = null;
    this.fFileList = null;
    this.fStartFolder = null;
    this.fCurrentFolder = null;
    this.fCurrentFile = null;
    this.fAcceptUploads = true;
    this.setCurrentFiles = null;
    this.setCurrentFolders = null;
    this.setCurrentOpenFolder = null;
    this.setCurrentSelectedFile = null;
    this.handleFileClick = null;
    this.setReady = null; // statusController hook
    this.setLoading = null; // statusController hook
    this.userRoles = {
      [kAdminUser]: ["read", "write", "addfolder"],
      [kRWUser]: ["read", "write"],
      [kROUser]: ["read"]
    };
  }

  InitFileMgr(wsMgr, startFolder, mode, curFile, srcElement, parentPanel) {
    this.fParentPanel = parentPanel;
    this.fWSMgr = wsMgr;
    this.fStartDirectory = startFolder;
    this.fMode = mode;
    this.fCurrentFile = curFile;
    this.fUIColors = wsMgr.GetUIColors();
    this.fReader = Globals._accountInfo.ReadOnlyMode();
    this.fSrcElement = srcElement;
    this.fOriginalDir = startFolder;
    this.fOriginalName = curFile;
    this.fUIColors = wsMgr.GetUIColors();
    this.fWSMgr = wsMgr;
    this.fBackgroundPanel = wsMgr.fBackgroundPanel;
    this.fAccessGroupMgr = wsMgr.GetAccessGroupMgr();
    //TODO: I don't like bundling the manager concept with the UI like I do here, but there isn't any other logical place
    //for this to live - the light/frameless classes are bundled pretty tightly.
    this.SetFileTypeRestrictions();
  }

  SetFilterMode(mode) {
    this.fFilterMode = mode;
  }

  GetCurrentFilterList() {
    var filterMode = this.GetFilterMode();
    return filterMode["exts"];
  }

  GetCurrentFilterLabel() {
    var filterMode = this.GetFilterMode();
    return filterMode["label"];
  }

  GetFilterMode(retrieveMode) {
    var filterList = this.GetAllFileTypes();
    var filterLabel = appstr("All Files");
    var curMode = retrieveMode != null ? retrieveMode : this.fFilterMode;

    switch (curMode) {
      case enumFileFilterMode.all:
        break;
      case enumFileFilterMode.charts:
        filterList = kChartDocExtensions;
        filterLabel = appstr("Chart Documents");
        break;
      case enumFileFilterMode.flatfiles:
        filterList = kFlatFileList;
        filterLabel = appstr("Flat Files");
        break;
      case enumFileFilterMode.backgrounds:
        filterList = kBackgroundExtensions;
        filterLabel = appstr("Backgrounds");
        break;
      case enumFileFilterMode.images:
        filterList = ["jpg", "png"];
        filterLabel = appstr("Images");
        break;
    }
    return { exts: filterList, label: filterLabel };
  }

  BuildFilterModes() {
    var filterList = [];
    for (var i in enumFileFilterMode) {
      var aMode = enumFileFilterMode[i];
      var filterDetails = this.GetFilterMode(aMode);
      filterDetails["mode"] = aMode;
      filterDetails["current"] = this.fFilterMode == aMode;
      filterList.push(filterDetails);
    }
    return filterList;
  }

  // file restrictions for selecting files when in specific modes that restrict file types
  GetFileTypeRestrictions() {
    return this.fFileTypeRestrictions;
  }

  GetAllFileTypes() {
    var basicList = ["oc5c", "xls", "xlsx", "csv", "xml", "txt", "jpg", "jpeg", "png", "json"];
    var charts = kChartDocExtensions;
    var backgrounds = kBackgroundExtensions;
    var fullList = basicList.concat(charts);
    fullList = fullList.concat(backgrounds);
    return fullList;
  }

  SetFileTypeRestrictions() {
    var restrictList = this.GetAllFileTypes();
    var filterMode = enumFileFilterMode.all;
    switch (this.fMode) {
      case enumFileMgrMode.upload:
      case enumFileMgrMode.uploadIW:
      case enumFileMgrMode.charts:
      case enumFileMgrMode.open:
      case enumFileMgrMode.saveas:
      case enumFileMgrMode.comparefile:
      case enumFileMgrMode.selectcustomchart:
        restrictList = kChartDocExtensions;
        filterMode = enumFileFilterMode.charts;
        break;
      case enumFileMgrMode.importfile:
      case enumFileMgrMode.importfileSA:
        restrictList = kFlatFileList;
        filterMode = enumFileFilterMode.flatfiles;
        break;
      case enumFileMgrMode.selectbackground:
      case enumFileMgrMode.openmaster:
      case enumFileMgrMode.savemaster:
      case enumFileMgrMode.selectmasterSA:
      case enumFileMgrMode.selectmasterIW:
      case enumFileMgrMode.selectmasterRP:
        restrictList = kBackgroundExtensions;
        filterMode = enumFileFilterMode.backgrounds;
        break;
      case enumFileMgrMode.replaceimage:
      case enumFileMgrMode.selectimage:
      case enumFileMgrMode.selectcellimage:
        restrictList = ["jpg", "png"];
        filterMode = enumFileFilterMode.images;
        break;
      case enumFileMgrMode.xls:
        restrictList = ["xls", "xlsx"];
        filterMode = enumFileFilterMode.flatfiles;
        break;
      case enumFileMgrMode.csv:
        restrictList = ["csv"];
        filterMode = enumFileFilterMode.flatfiles;
        break;
      case enumFileMgrMode.excel:
        restrictList = ["xls", "xlsx", "csv"];
        filterMode = enumFileFilterMode.flatfiles;
        break;
      case enumFileMgrMode.xml:
        restrictList = ["xml"];
        filterMode = enumFileFilterMode.flatfiles;
        break;
      case enumFileMgrMode.json:
        restrictList = ["json"];
        filterMode = enumFileFilterMode.flatfiles;
        break;
      case enumFileMgrMode.manual:
        restrictList = ["json", "csv", "xls", "xlsx"];
        filterMode = enumFileFilterMode.flatfiles;
        break;
    }
    this.fFilterMode = filterMode;
    this.fFileTypeRestrictions = restrictList;
  }

  DirResult(r, loadFolders, folder) {
    r = JSON.parse(r);
    var proceed = true; // why ?
    var success = r["message"];

    if (proceed) {
      if (loadFolders) {
        if (!success) {
          var w = new QAlert();
          w.InitAlert(
            appstr("Alert"),
            appstr("fileinfoerror"),
            this.fParentPanel,
            this.fWSMgr,
            true
          );
          this.CallDirRFC("", true);
        } else this.FolderDirResult(r);
      }
      if (!loadFolders) {
        if (!success) {
          var curFolder = this.GetCurrentFolderName();
          var w = new QAlert();
          w.InitAlert(
            appstr("Alert"),
            appstr("fileinfoerror"),
            this.fParentPanel,
            this.fWSMgr,
            true
          );
          this.CallDirRFC(curFolder, false);
        } else {
          var queryDir = r["query"];
          //this.SetRenameElement(null);
          this.FileDirResult(r, folder);
          this.cacheFolder(queryDir);
        }
      }
    }
  }

  GetCurrentFolder() {
    return this.fCurrentFolder;
  }

  ValidFile(file) {
    var ext = file.extension;
    var restrictList = this.fFileTypeRestrictions;
    if (restrictList == null || (restrictList && restrictList.length == 0)) return file;
    else if (restrictList.indexOf(ext) == -1) return null;
    return file;
  }

  IncludeInFilter(file) {
    var ext = file.extension;
    var filterList = this.GetCurrentFilterList();
    if (filterList == null || (filterList && filterList.length == 0)) return file;
    else if (filterList.indexOf(ext) == -1) return null;
    return file;
  }

  DownloadFile(file) {
    var wsMgr = this.fWSMgr;

    var theDirectory = this.GetCurrentFolderName();
    var filename = file ? file.GetFileName(true) : this.GetSelectedFileName();

    wsMgr.DownloadFile(theDirectory, filename);
  }

  SetFolderList(folderList, currentFolder) {
    this.fFolderList = folderList;
    this.fCurrentFolder = currentFolder;
    this.setCurrentOpenFolder(currentFolder);
    this.setCurrentFolders(folderList);
    this.FolderSelected(currentFolder);
  }

  FileSelected(currentFile) {
    var currentFilename = currentFile?.GetFileName(true) ?? null;
    this.fCurrentFile = currentFilename;
    this.fLastSelectedFile = currentFilename;
    this.setCurrentSelectedFile(currentFile);
  }

  DoFilePreview(aFileName, fileInfo) {
    if (this.fLastSelectedFile !== aFileName) {
      if (aFileName != null) this.CallFilePreviewRFC(aFileName, fileInfo);
    }
  }

  FindFolderByName(folderName) {
    var n = this.fFolderList.length;
    for (var i = 0; i < n; i++) {
      var aFolder = this.fFolderList[i];
      if (aFolder.GetFolderName() == folderName) return aFolder;
    }

    return null;
  }

  FindFileByName(fileName) {
    var n = this.fFileList.length;
    for (var i = 0; i < n; i++) {
      var aFile = this.fFileList[i];
      if (aFile.GetFileName() == fileName) return aFile;
    }

    return null;
  }

  SetCanDropUpload(canUpload) {
    this.fAcceptUploads = canUpload;
  }

  GetCanDropUpload() {
    return this.fAcceptUploads;
  }

  GetSelectedFileName() {
    return this.fCurrentFile;
  }

  GetSaveAsMaster() {
    return this.fMode === enumFileMgrMode.savemaster;
  }

  InSaveMode() {
    return this.fMode === enumFileMgrMode.saveas || this.fMode === enumFileMgrMode.savemaster;
  }

  InUploadFileMgrMode() {
    return this.fMode === enumFileMgrMode.upload;
  }

  ValidExtension() {
    var curFile = this.GetCurrentFile();
    if (!this.InSaveMode()) {
      var curExt = GetExtension(curFile);
      var filterModeList = this.GetFileTypeRestrictions();
      return filterModeList.includes(curExt);
    }
    if (this.fMode === enumFileMgrMode.saveas)
      return curFile.includes(".oc5") || curFile.includes(".ocd"); //TODO: Make this more concise
    if (this.fMode === enumFileMgrMode.savemaster)
      return curFile.includes(".oc5m") || curFile.includes(".ocb");
    return true;
  }

  GetCurrentFile() {
    // grab from modal TE
    let currentFileName = this.fCurrentFile;
    if (this.InSaveMode()) {
      let textEdit = document.getElementById("ocn-filemanager-name-input");
      if (textEdit) currentFileName = textEdit.value;
      else currentFileName = "";
    }
    return currentFileName;
  }

  GetCurrentFileName() {
    var curFile = this.GetCurrentFile();
    if (curFile) {
      if (!this.ValidExtension() && this.InSaveMode()) {
        if (this.GetSaveAsMaster()) curFile += ".ocb";
        else curFile += ".ocd";
      }
      this.fCurrentFile = curFile;
    }
    return curFile;
  }

  GetSourceElement() {
    return this.fSrcElement;
  }

  IsBackground() {
    var f = this.fCurrentFile;
    var isMaster = false;
    if (f != null) isMaster = IsBackgroundFile(f);

    return isMaster;
  }

  CanOpenFile() {
    var f = this.GetCurrentFileName();
    var canOpen = false;
    if (f != null) {
      canOpen = IsBackgroundFile(f) || IsOrgChartFile(f);
    }
    return canOpen;
  }

  GetMode() {
    return this.fMode;
  }

  // Set when renaming a file or folder
  SetRenameElement(renameElement) {
    this.fRenameElement = renameElement;
    //this.fFileMgrPanel.UpdatePagingControls();
  }

  GetRenameElement() {
    return this.fRenameElement;
  }

  GetImageMgr() {
    return this.fWSMgr.GetImageMgr();
  }

  ClearFoldersCache() {
    for (var i = 0; i < this.fFolderList.length; i++) {
      this.clearCache(this.fFolderList[i]);
    }
  }

  ClearFolderCache(folder) {
    var folderObj = folder ? folder : this.GetCurrentFolder();
    var folderName = folder ? folder.GetFolderName() : this.GetCurrentFolderName();
    this.clearCache(folderObj);
    this.doCachedFolder(folderName);
  }

  RefreshCurrentDirectory(folder) {
    var folderObj = folder ? folder : this.GetCurrentFolder();
    var folderName = folder ? folder.GetFolderName() : this.GetCurrentFolderName();
    this.clearCache(folderObj);
    this.doCachedFolder(folderObj);
    this.CallDirRFC(folderName, false);
  }

  CompleteRename() {
    var renameElement = this.GetRenameElement();
    if (renameElement != null) {
      renameElement.ExitEditMode();
      this.SetKeyboardTarget(null);
      return true;
    } else {
      this.SetKeyboardTarget(null); // need to give keyboard priority back to search panel
    }

    return false;
  }

  FolderSelected(aFolder) {
    this.setCurrentOpenFolder(aFolder);
    this.fCurrentFolder = aFolder;
    var folderName = aFolder.GetFolderName();
    var fileDict = aFolder.IsCached();
    this.doCachedFolder(aFolder);
    if (!fileDict) {
      this.CallDirRFC(folderName, false);
    }
  }

  DoCustomCopy(clipBoard) {}

  UpdateFilePreview() {
    // todo turn on when you have toggle button
    return;
    var fileMgrPanel = this.fPickerPanel;
    if (fileMgrPanel.fFilePreview)
      fileMgrPanel.fFilePreview.SetShownState(fileMgrPanel.fPreviewState);
  }

  DoUpdatePreviewDetails(response, fileInfo) {
    var success = response["success"];
    if (fileInfo == null) return;
    if (success) {
      var result = response["message"];
      var fileObj = fileInfo;

      fileObj.fAuthor = result["author"];
      fileObj.fImageSize = result["imageSize"];

      var pickerPanel = this.fPickerPanel;
      if (pickerPanel.fFilePreview) {
        pickerPanel.fFilePreview.UpdatePreview(fileObj);
      }
    }
  }

  FileDeselected(aFileName) {
    if (!this.InSaveMode()) {
      this.fCurrentFile = "";
      this.UpdateFilePreview();
    }
  }

  CloseActiveFolderRename() {
    this.fCurFolderElement = null;
  }

  CloseActiveFileRename() {
    this.fCurFileElement = null;
  }

  FileUploadMsg(fileName, statusCode) {
    // restore
  }

  GetFolderByFolderName(fN) {
    var folderList = this.fFolderList;
    for (var aFolderIdx in folderList) {
      if (folderList[aFolderIdx].fFolderName === fN) {
        return folderList[aFolderIdx];
      }
    }
    return false;
  }

  GetCurrentFolderName() {
    var cFolder = this.GetCurrentFolder();
    var fN = null;
    if (cFolder != null) fN = cFolder.GetFolderName();

    return fN;
  }

  GetCurrentFolderLocked() {
    var cFolder = this.GetCurrentFolder();
    var folderLocked = true;
    if (cFolder != null) folderLocked = cFolder.IsLocked();

    return folderLocked;
  }

  //=================================================================================================
  // Rename Folder/File
  RenameFolder(x = null, y = null, folderElement = null) {
    if (folderElement == null) {
      var targetPanel = this.fFolderPickerPanel.fPortPanel;
      var selList = targetPanel.GetSelectionList();
      var numSelected = 0;
      if (selList != null) numSelected = selList.length;

      if (numSelected != 1) return;
    }

    var cFolder = this.GetCurrentFolder();
    if (this.LockedMsg(cFolder, "folderlocked") || this.IsSpecialFolder()) return;

    if (folderElement == null) {
      var targetFolderElement = selList[0];
    } else {
      targetFolderElement = folderElement;
    }

    this.fCurFolderElement = targetFolderElement;
    this.fWSMgr.SetTarget(targetPanel, targetFolderElement);
    this.fWSMgr.SetKeyboardTarget(
      targetFolderElement,
      targetPanel,
      enumKeyboardTargetEnterAction.selectAll
    );
    this.SetKeyboardTarget(targetFolderElement);
    targetFolderElement.DoEnterEditMode(x, y);
  }

  GetFileListPanel() {
    return this.fFileListPanel;
  }

  GetFolderListPanel() {
    return this.fFolderPickerPanel;
  }

  // CONTROLCHANGE
  RenameFile(x = null, y = null, fileElement = null) {
    var filePanel = this.GetFileListPanel();

    if (fileElement == null) {
      var selList = filePanel.fPortPanel.GetSelectionList();
      var numSelected = 0;
      if (selList != null) numSelected = selList.length;

      if (numSelected != 1) return;
    }

    var cFolder = this.GetCurrentFolder();

    if (this.LockedMsg(cFolder, "filelocked")) return;

    if (fileElement == null) {
      var targetFileElement = selList[0];
    } else {
      targetFileElement = fileElement;
    }

    this.fCurFileElement = targetFileElement;
    this.fWSMgr.SetTarget(filePanel.fPortPanel, targetFileElement);
    this.fWSMgr.SetKeyboardTarget(
      targetFileElement,
      filePanel.fPortPanel,
      enumKeyboardTargetEnterAction.selectAll
    );
    this.SetKeyboardTarget(targetFileElement);
    targetFileElement.DoEnterEditMode(x, y);
  }

  SetKeyboardTarget(targetElement) {
    this.fDefaultKBTarget = targetElement;
  }

  GetKeyboardTarget() {
    return this.fDefaultKBTarget;
  }

  // Called from the textedit commit
  DoRenameFolder(curName, newName) {
    if (curName == newName) return;
    if (!ValidateRename(newName, this.fWSMgr).valid) return;

    this.CallRenameRFC("", curName, newName, "folder");
  }

  DoRenameFile(curName, newName, callback, theDir) {
    if (curName === newName) return;
    if (!ValidateRename(StripExtension(newName), this.fWSMgr).valid) return;

    var curDir = theDir || this.GetCurrentFolderName();
    this.fRenameCallback = callback;
    this.CallRenameRFC(curDir, curName, newName, "file");
  }

  CallRenameRFC(
    directory,
    curName,
    newName,
    entityType /// replace with filerfc
  ) {
    var curFolder = this.GetCurrentFolder();
    this.clearCache(curFolder);
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();
    var renameRFC = new QFileRFC();
    renameRFC.InitFileRFC(this, entityType, directory);
    renameRFC.SetParams(org, user, "rename", {
      curname: curName,
      newname: newName,
      entitytype: entityType,
      dir: directory
    });
    Globals._rfcMgr.QueueRFC(renameRFC);
  }

  RenameFolderResult(response) {
    var newName = null;
    var result = response["success"];
    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("renamefolder"), null, this.fWSMgr, true);
      this.fStartDirectory = null;
      this.CallDirRFC("", true);
    } else {
      newName = response["message"];
      var curFolder = this.GetCurrentFolderName();
      if (curFolder === newName) this.fStartDirectory = newName;
      else this.fStartDirectory = curFolder;
      this.CallDirRFC("", true);
    }
  }

  RenameFileResult(response, directory) {
    var newName = null;
    var result = response["success"];
    var curFolder = this.GetCurrentFolderName();
    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("renameerr"), null, this.fWSMgr, true);
      this.CallDirRFC(curFolder, false);
    } else {
      newName = response["message"];
      newName = this.ValidFile(newName);
      if (curFolder === directory) {
        this.fStartDirectory = directory;
        this.fStartFileName = newName;
      }

      var promise = this.CallDirRFC(directory, false);
      if (this.fRenameCallback && typeof this.fRenameCallback === "function") {
        promise.then(() => {
          this.fRenameCallback();
          this.fRenameCallback = null;
        });
      }
    }
  }

  //===================================================================
  // File Info
  FileResult(r, mode, entityType, dirStart, files, data) {
    switch (mode) {
      case "delete":
        entityType === "folder" ? this.FolderDelResult(r) : this.FileDelResult(r, data);
        break;
      case "move":
        this.MoveFilesResult(r, dirStart, data);
        break;
      case "rename":
        entityType === "folder" ? this.RenameFolderResult(r) : this.RenameFileResult(r, dirStart);
        break;
      case "copy":
        this.DuplicateFileResult(r, dirStart);
        break;
      case "addfolder":
        this.FolderAddResult(r);
        break;
      case "unzip":
        this.UnzipResult(r);
        break;
      case "preview":
        //if (this.fLastSelectedFile === filename) this.DoUpdatePreviewDetails(r, dirStart);
        break;
    }
  }

  //=================================================================================================
  // Add Folders
  CallAddFolderRFC() {
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();
    var addFolderRFC = new QFileRFC();
    addFolderRFC.InitFileRFC(this, "folder", "");
    addFolderRFC.SetParams(org, user, "addfolder", { data: "none" });
    Globals._rfcMgr.QueueRFC(addFolderRFC);
  }

  CallFilePreviewRFC(fileName, fileObj) {
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();

    var folder = this.GetCurrentFolderName();
    var previewRFC = new QFileRFC();
    previewRFC.InitFileRFC(this, "file", fileObj, fileName);
    previewRFC.SetParams(org, user, "preview", {
      filename: fileName,
      folder: folder
    });
    Globals._rfcMgr.QueueRFC(previewRFC);
  }

  AddNewFolder() {
    this.CallAddFolderRFC();
  }

  FolderAddResult(response) {
    var result = response["success"];
    var accessGroupMgr = this.fAccessGroupMgr;
    var curFolder = this.GetCurrentFolderName();
    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("folderadderr"), null, this.fWSMgr, true);
      this.fStartDirectory = null;
      this.CallDirRFC(curFolder, false);
    } else {
      var dirList = [response["message"]["foldername"]];
      var finalList = ApplyAccessGroup(this.fWSMgr, accessGroupMgr, dirList, true, true);
      var folderName = finalList[0].name;
      var groupStatus = finalList[0].groupstatus;
      var locked = groupStatus === enumFolderStatus.ingrouplocked;
      var folder = new QFolder();
      folder.InitFolder(folderName, locked, this);
      this.fStartDirectory = folderName;

      var folderList = this.fFolderList;
      var index = folderList.length - 3;

      folderList.splice(index, 0, folder);
      this.SetFolderList(folderList, folder);
    }
  }

  //=================================================================================================
  // Delete Files and Folders
  CallDeleteRFC(thePath, entityType, entityList) {
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();
    var deleteRFC = new QFileRFC();
    deleteRFC.InitFileRFC(this, entityType);
    deleteRFC.SetParams(org, user, "delete", {
      thePath: thePath,
      names: entityList,
      entitytype: entityType
    });
    Globals._rfcMgr.QueueRFC(deleteRFC);
  }

  GetPrevFile(delFile) {
    var parentFolder = delFile.GetParentFolder();
    var i = parentFolder.GetFullNameIndex(delFile.GetFileName(true));
    if (i <= 0) return null;

    var prevFile = parentFolder.GetIndexFile(i - 1);
    return prevFile;
  }

  DoDeleteSelectedFiles(allFiles, file, skipAlert = false) {
    var entityList = [];
    var w = this.fWSMgr;
    var docMgr = w.GetDocMgr();
    //var filePanel = this.GetFileListPanel();
    if (allFiles) {
      var cFolder = this.GetCurrentFolder();
      var n = cFolder.GetNumFiles();
      for (var i = 0; i < n; i++) {
        var aFile = cFolder.GetIndexFile(i);
        entityList.push(aFile.GetFileName(true));
      }
      this.fStartFileName = null;
    } else {
      //var selList = filePanel.fPortPanel.GetSelectionList();
      var selList = [file];
      var numSelected = 0;
      if (selList != null) numSelected = selList.length;

      if (numSelected === 0) return;

      for (i = 0; i < numSelected; i++) {
        aFile = selList[i];
        entityList.push(aFile.GetFileName(true));
      }

      this.fStartFileName = null;
    }

    if (entityList.length == 0) return;

    var fileMgr = this;

    if (!skipAlert) {
      var proceed = this.ConfirmUpdateEntity(entityList, () => {
        fileMgr.DoDeleteSelectedFiles(allFiles, file, true);
        fileMgr.PostUpdateEntity(entityList, true);
      });
      if (!proceed) return;
    }

    var entityStr = entityList.join(":");
    var theFolder = this.GetCurrentFolderName();
    var folder = this.GetCurrentFolder();
    this.clearTrashCache();
    this.clearCache(folder);
    this.CallDeleteRFC(theFolder, "file", entityStr); //replace with fileRFC
    this.FileSelected(null);
  }

  LockedMsg(cFolder, message) {
    if (cFolder.IsLocked()) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr(message), null, this.fWSMgr);
      return true;
    }
    return false;
  }

  DeleteSelectedFiles(allFiles) {
    var cFolder = this.GetCurrentFolder();
    if (this.LockedMsg(cFolder, "filelocked")) return;

    var isTrash = cFolder.GetFolderType() == enumFolderType.trash;

    if (isTrash || allFiles) {
      var okCode = "OKDeleteFile";
      var infoText = appstr("permdel");
      var headerText = appstr("Permanently delete file");
      var yesStr = appstr("Delete");
      var noStr = appstr("Cancel");

      if (allFiles) {
        var currentFolder = this.GetCurrentFolder();
        var folderName = currentFolder.GetFolderName();
        var fileCount = currentFolder.GetNumFiles();

        if (IsHiddenFolder(folderName) || fileCount < 1) return false;

        var msg = isTrash ? "Delete all files trash" : "Send all files to trash";

        okCode = "OKDeleteAllFiles";
        headerText = isTrash ? appstr("Delete all files") : appstr("Move all files to trash");
        yesStr = isTrash ? appstr("Empty trash") : appstr("Move files to trash");

        infoText = appstr(msg, {
          fileCount: fileCount,
          folder: folderName
        });
      }

      this.fWSMgr.CreateReactAlert(
        headerText,
        infoText,
        () => this.HandleCommand(okCode),
        () => {},
        yesStr,
        noStr
      );
    } else {
      this.DoDeleteSelectedFiles(false);
    }
  }

  FileDelResult(response, data) {
    var result = response["success"];
    var cFolder = this.GetCurrentFolderName();
    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("deleteerr"), null, this.fWSMgr, true);
      this.CallDirRFC(cFolder, false);
    } else {
      this.RefreshActiveBackground(data);
      this.CallDirRFC(cFolder, false);
    }
  }

  ConfirmUpdateEntity(files, proceedFn, isDelete = true) {
    var wsMgr = this.fWSMgr;
    var bgMgr = wsMgr.fBackgroundMgr;
    var docMgr = wsMgr.GetDocMgr();
    var activeBackground = bgMgr.GetCurBackgroundName();
    var header = "";
    var info = "";
    var confirm = "";
    if (files.includes(activeBackground) || files.some(IsBackgroundFile)) {
      if (isDelete) {
        header = appstrp("Delete background", "?");
        info = appstr("Are you sure you want to delete background");
      } else {
        header = appstrp("Move background", "?");
        info = appstr("Are you sure you want to move background");
      }
      confirm = appstr("Continue");
    }
    if (files.includes(docMgr.GetFileName(true)) && isDelete) {
      header = appstrp("Delete open chart", "?");
      info = appstrp(
        "This custom chart is currently open. Are you sure you want to delete this custom chart",
        "?"
      );
      confirm = appstr("Delete");
    }
    if (header !== "") {
      var headerText = header;
      var yesStr = confirm;
      var noStr = appstr("Cancel");
      var infoText = info;
      wsMgr.CreateReactAlert(headerText, infoText, proceedFn, () => {}, yesStr, noStr);
      return false;
    }
    return true;
  }

  PostUpdateEntity(entityList, isDeleted) {
    var wsMgr = this.fWSMgr;
    var docMgr = wsMgr.GetDocMgr();

    if (isDeleted && entityList.includes(docMgr.GetFileName(true))) {
      Globals._uiConfig.SetChartOpenMode(enumChartOpenModes.masterchart);
      wsMgr.ChangeDoc("Viewer");
    }
  }

  RefreshActiveBackground(data) {
    var wsMgr = this.fWSMgr;
    var doc = wsMgr.GetDoc();
    var iWiz = doc.GetIWizData();
    var targetNames = data.names.split(":");
    var bgMgr = wsMgr.fBackgroundMgr;
    var activeBackground = bgMgr.GetCurBackgroundName();

    if (targetNames.includes(activeBackground) && iWiz.GetMasterOption() === enumBGOption.linked) {
      bgMgr.BustMasterCache(activeBackground);
      bgMgr.ClearActiveBackground();
    }
  }

  GetFolderIndex(targetFolder) {
    var folderList = this.fFolderList;
    var n = folderList.length;
    var done = false;
    var i = 0;

    while (!done) {
      var aFolder = folderList[i];
      if (targetFolder == aFolder) done = true;
      else {
        i++;
        if (i > n - 1) return -1;
      }
    }

    return i;
  }

  GetStartFolder(delFolder) {
    if (delFolder) {
      var i = this.GetFolderIndex(delFolder.fFolder);
      if (i <= 0) return null;
      else return this.fFolderList[i - 1];
    }
    return this.fFolderList[0];
  }

  DeleteSelectedFolder(delFolder) {
    var cFolder = this.GetCurrentFolder();
    if (this.LockedMsg(delFolder, "folderlocked")) return;

    const delFolderName = delFolder.GetFolderName();

    this.fStartDirectory = null;
    if (cFolder?.GetFolderName() === delFolderName) {
      var startFolder = this.GetStartFolder(delFolder);
      if (startFolder != null) this.fStartDirectory = startFolder.GetFolderName();
    }

    this.CallDeleteRFC(delFolderName, "folder", "");
  }

  FolderDelResult(response) {
    var result = response["success"];
    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("deletefoldererr"), null, this.fWSMgr, true);
      this.fStartDirectory = null;
      this.CallDirRFC("", true);
    } else this.CallDirRFC("", true);
  }

  DoUnzip() {
    var unzipRFC = Globals._fileMgr["unzipRFC"];
    Globals._rfcMgr.QueueRFC(unzipRFC);
  }

  UnzipFile() {
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();
    var filePanel = this.GetFileListPanel();
    var cFolder = this.GetCurrentFolder();
    if (this.LockedMsg(cFolder, "filelocked")) return;

    var foldername = cFolder.GetFolderName();
    var selList = filePanel.fPortPanel.GetSelectionList();
    var numSelected = 0;
    if (selList != null) numSelected = selList.length;
    if (numSelected == 0) return;

    var aFile = selList[0].GetFile();
    var fileName = aFile.GetFileName(true);

    var unzipRFC = new QFileRFC();
    unzipRFC.InitFileRFC(this, "file", foldername);
    unzipRFC.SetParams(org, user, "unzip", {
      dirname: foldername,
      filename: fileName
    });

    w.DoProgress(appstr("unzipping"));
    Globals._fileMgr = this;
    Globals._fileMgr["unzipRFC"] = unzipRFC;

    setTimeout(function () {
      doUnzip();
    }, 0);
  }

  UnzipResult(response) {
    var result = response["success"];

    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("unziperr"), null, this.fWSMgr, true);
    }

    this.RefreshCurrentDirectory();
    this.fWSMgr.EndProgress();
  }

  //=================================================================================================
  // Duplicate Files
  DuplicateSelectedFiles(file) {
    //var filePanel = this.GetFileListPanel();
    var selList = [file];
    var numSelected = 0;
    if (selList != null) numSelected = selList.length;

    if (numSelected == 0) return;

    var cFolder = this.GetCurrentFolder();
    if (this.LockedMsg(cFolder, "filelocked")) return;

    var entityList = [];
    for (var i = 0; i < numSelected; i++) {
      var aFile = selList[i];
      entityList.push(aFile.GetFileName(true));
    }

    this.fStartFileName = null;
    var entityStr = entityList.join(":");
    var thePath = this.GetCurrentFolderName();

    this.CallDuplicateRFC(thePath, entityStr);
  }

  CallDuplicateRFC(thePath, entityList) {
    var curFolder = this.GetCurrentFolder();
    this.clearCache(curFolder);
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();

    var dupRFC = new QFileRFC();
    dupRFC.InitFileRFC(this, "file", thePath);
    dupRFC.SetParams(org, user, "copy", {
      destdir: thePath,
      srcdir: thePath,
      names: entityList,
      operation: "copy"
    });
    Globals._rfcMgr.QueueRFC(dupRFC);
  }

  DuplicateFileResult(response, directory) {
    var result = response["success"];
    var newName = null;
    var curFolder = this.GetCurrentFolderName();
    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("duperr"), null, this.fWSMgr, true);
      this.fStartDirectory = null;
      this.CallDirRFC(directory, false);
    } else {
      newName = response["message"];
      newName = this.ValidFile(newName);

      if (curFolder === directory) {
        this.fStartDirectory = directory;
        this.fStartFileName = newName;
      }
      this.CallDirRFC(directory, false);
    }
  }

  //=================================================================================================
  // Directory Queries
  CallDirRFC(thePath, loadFolders) {
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();

    if (this?.setLoading) {
      this.setLoading();
    }

    var dirRFC = new QDirRFCJSON();
    var promise = dirRFC.GetPromise();

    promise.then(() => {
      if (this?.setReady) this.setReady();
    });

    dirRFC.InitDirRFC(this, loadFolders);
    dirRFC.SetParams(org, user, thePath);
    Globals._rfcMgr.QueueRFC(dirRFC);
    return promise;
  }

  GetFileTypeExtString(extArray) {
    return "(" + extArray.join(", ").toUpperCase() + ")";
  }

  FolderDirResult(response) {
    var accessGroupMgr = this.fAccessGroupMgr;
    var dirList = response["data"];
    var result = response["message"];

    if (result === "Success") {
      var org = Globals._accountInfo.PublicURLLaunch();
      var finalList;
      if (org) {
        finalList = [];
        var folderobj = new qfolderobj();
        folderobj.name = "Public";
        folderobj.groupstatus = enumFolderStatus.ingroup;
        finalList.push(folderobj);
      } else {
        finalList = ApplyAccessGroup(this.fWSMgr, accessGroupMgr, dirList, true, true);
        finalList = finalList.sortBy(true, "name");
      }

      var n = finalList.length;

      var trashFolder = null;
      var sampleFolder = null;
      var publicFolder = null;
      var startFolder = null;
      var folderList = [];

      for (var i = 0; i < n; i++) {
        var folderName = finalList[i].name;
        var displayName = null;
        var groupStatus = finalList[i].groupstatus;
        var locked = groupStatus === enumFolderStatus.ingrouplocked;
        var folder = new QFolder();
        if (folderName === "Masters") displayName = "Backgrounds";
        folder.InitFolder(folderName, locked, this, displayName);
        if (folderName != null && this.fStartDirectory != null)
          if (folderName.toLowerCase() === this.fStartDirectory.toLowerCase()) startFolder = folder;

        var folderType = folder.GetFolderType();
        var readOnly = Globals._accountInfo.GetUserRole() === kROUser;
        var ignoreFolder = folder.ExcludeFolders(readOnly);
        if (!ignoreFolder) {
          switch (folderType) {
            case enumFolderType.std:
            case enumFolderType.stdlock:
              folderList.push(folder);
              break;
            case enumFolderType.sample:
              sampleFolder = folder;
              break;
            case enumFolderType.trash:
              trashFolder = folder;
              break;
            case enumFolderType.publicf:
              publicFolder = folder;
              break;
          }
        }
      }

      if (publicFolder != null) folderList.push(publicFolder);

      if (sampleFolder != null) folderList.push(sampleFolder);

      if (trashFolder != null) folderList.push(trashFolder);

      if (startFolder == null) startFolder = folderList[0];
      this.fFolderList = folderList;
      if (startFolder) {
        this.SetFolderList(folderList, startFolder);
      }
    }
  }

  SetFileList(aFolder) {
    aFolder.SetReady();
    var mode = this.GetMode();
    // TODO need to pass file obj of current file selected to FileSelected (when launching into mode where file is pre-selected
    //if (mode !== enumFileMgrMode.saveas && mode !== enumFileMgrMode.savemaster)
    //	this.FileSelected(this.fCurrentFile && this.fCurrentFile !== appstr("notset") ? this.fCurrentFile : "");
    this.fFileList = aFolder.fFileList;
    this.setCurrentFiles(this.fFileList);
  }

  FileDirResult(response, folderName) {
    var dirResult = response["data"];
    var result = response["message"];
    var aFolder = result != "folder does not exist" ? this.FindFolderByName(folderName) : null;

    if (aFolder == null) return;

    if (aFolder.fFileList != null) aFolder.ClearFolder();
    else aFolder.fFileList = [];

    aFolder.fFileCount = 0;

    if (result === "Success") {
      dirResult = dirResult.sortBy(true, "filename");
      var n = dirResult.length;
      var selectedFile = null;
      for (var i = 0; i < n; i++) {
        aFolder.fFileCount += 1;
        var fileName = this.IncludeInFilter(dirResult[i]);
        if (fileName) {
          var file = aFolder.AddFile(fileName);
          var fileName = file.GetFileName(true);
          if (
            this.fCurrentFile &&
            fileName &&
            this.fCurrentFile.toLowerCase() === fileName.toLowerCase()
          ) {
            selectedFile = file;
          }
        }
      }

      this.SetFileList(aFolder);
      this.setCurrentOpenFolder(aFolder);

      if (selectedFile != null && this.fCurrentFile != null) {
        this.handleFileClick({ value: selectedFile });
      }
    }
  }

  doCachedFolder(aFolder) {
    if (aFolder) {
      this.fFileList = aFolder.fFileList;
      this.setCurrentFiles(this.fFileList);
    }
  }

  clearCache(aFolder) {
    if (aFolder == null) return;
    aFolder.SetCacheState(false);
    aFolder.ClearCache();
  }

  clearTrashCache() {
    var trashFolder = this.GetFolderByFolderName("Trash");
    if (trashFolder) this.clearCache(trashFolder);
  }

  cacheFolder(folderName) {
    var folderList = this.fFolderList;
    for (var aFolder in folderList) {
      if (folderList[aFolder].fFolderName == folderName) {
        var targetFolder = folderList[aFolder];
        targetFolder.SetCacheState(true);
        break;
      }
    }
  }

  //=================================================================================================
  // Command Handling
  HandleCommand(code) {
    switch (code) {
      // File Mgr
      case "DeleteFile":
        this.DeleteSelectedFiles(false);
        break;
      case "DeleteAllFiles":
        this.DeleteSelectedFiles(true);
        break;
      case "OKDeleteAllFiles":
        this.DoDeleteSelectedFiles(true);
        break;
      case "DuplicateFile":
        this.DuplicateSelectedFiles();
        break;
      case "RenameFile":
        this.RenameFile();
        break;
      case "DeleteFolder":
        this.DeleteSelectedFolder();
        break;
      case "AddFolder":
        this.AddNewFolder();
        break;
      case "RenameFolder":
        this.RenameFolder();
        break;
      case "UnzipFile":
        this.UnzipFile();
        break;
      case "FileTools":
        /*
        var sourcePanel = aCmd.GetSourcePanel();
        sourcePanel.AddDropDown(
          aCmd.GetWSMgr(),
          null,
          "FileToolCmd",
          ["comparedirs"],
          "",
          aCmd.GetSourceElement(),
          160,
          true
        );
         */
        break;
    }
  }

  NumFilesSelected() {
    if (
      this.fFileListPanel == null ||
      (this.fFileListPanel && this.fFileListPanel.fPortPanel == null)
    )
      return 0;

    var filePanel = this.GetFileListPanel();
    var selList = filePanel.fPortPanel.GetSelectionList();
    var numSelected = 0;
    if (selList != null) numSelected = selList.length;

    return numSelected;
  }

  NumFoldersSelected() {
    if (
      this.fFolderPickerPanel == null ||
      (this.fFolderPickerPanel && this.fFolderPickerPanel.fPortPanel == null)
    )
      return 0;

    var selList = this.fFolderPickerPanel.fPortPanel.GetSelectionCache();
    var numSelected = 0;
    if (selList != null) numSelected = selList.length;

    return numSelected;
  }

  IsSpecialFolder(folder) {
    // Trash and Samples do not allow rename or duplicate
    var isSpecial = false;
    var curFolder = folder ? folder : this.GetCurrentFolder();
    if (curFolder) {
      var isMaster = kSpecialFolders.includes(curFolder.fFolderName.toLowerCase());
      var folderType = curFolder.GetFolderType();
      switch (folderType) {
        case enumFolderType.std:
        case enumFolderType.stdlock:
          isSpecial = isMaster;
          break;
        default:
          isSpecial = true;
          break;
      }
    }

    return isSpecial;
  }

  IsTrashFolder() {
    var curFolder = this.GetCurrentFolder();
    if (curFolder && curFolder.GetFolderType() == enumFolderType.trash) return true;

    return false;
  }

  CanDeleteCurrentFolder(folder) {
    var curFolder = folder ? folder : this.GetCurrentFolder();
    var isLoading = curFolder.fFileList == null;

    if (curFolder == null || isLoading) return false;

    // Ready is set after folder directory has been queried from server
    if (!curFolder.IsReady()) return false;

    if (curFolder.GetNumFiles() > 0) return false;

    return true;
  }

  //=================================================================================================
  // Move Files
  MoveFiles(fileList, srcDir, destDir, srcLocked, destLocked, skipAlert = false) {
    var shiftDown = this.fWSMgr.ShiftDown();
    var operation = "move";
    if (shiftDown) {
      operation = "copy";
      if (srcLocked && !destLocked) srcLocked = false;
    }

    if (srcLocked || destLocked) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("filelocked"), null, this.fWSMgr);
      return;
    }

    var destFolder = this.GetFolderByFolderName(destDir);
    var entityStr = fileList.join(":");
    var fileMgr = this;
    if (!skipAlert) {
      var isDelete = destFolder.GetFolderType() === enumFolderType.trash;
      var proceed = this.ConfirmUpdateEntity(
        fileList,
        () => {
          fileMgr.MoveFiles(fileList, srcDir, destDir, srcLocked, destLocked, true);
          fileMgr.PostUpdateEntity(fileList, isDelete);
        },
        isDelete
      );
      if (!proceed) return;
    }
    this.CallMoveFilesRFC(entityStr, srcDir, destDir, operation);
  }

  CallMoveFilesRFC(
    files,
    srcDir,
    destDir,
    operation // move files rfc
  ) {
    var curFolder = this.GetCurrentFolder();
    var destFolder = this.GetFolderByFolderName(destDir);
    if (destFolder) this.clearCache(destFolder);
    this.clearCache(curFolder);
    var w = this.fWSMgr;
    var org = w.GetAccountName();
    var user = w.GetUserName();
    var moveFilesRFC = new QFileRFC();
    moveFilesRFC.InitFileRFC(this, "file", srcDir);
    moveFilesRFC.SetParams(org, user, "move", {
      srcdir: srcDir,
      destdir: destDir,
      operation: operation,
      names: files
    });
    Globals._rfcMgr.QueueRFC(moveFilesRFC);
  }

  MoveFilesResult(response, directory, data) {
    var result = response["success"];
    if (!result) {
      var w = new QAlert();
      w.InitAlert(appstr("Alert"), appstr("moveerr"), null, this.fWSMgr, true);
      this.CallDirRFC(directory, false);
    } else {
      this.fStartDirectory = directory;
      this.RefreshActiveBackground(data);
      this.CallDirRFC(directory, false);
    }
  }

  //=================================================================================================
  FileExistsInCurDirectory(fullName) {
    var curFolder = this.GetCurrentFolder();
    var index = curFolder.GetFullNameIndex(fullName);
    if (index == -1) return false;
    else return true;
  }

  InvalidFileSelectedAlert() {
    var restrictList = this.GetFileTypeRestrictions();
    var allowedList = restrictList.join(", ");
    var baseMsg = appstr("wrongextension") + " " + appstr("wrongextension2") + " " + appstr("File");
    var suppressHint =
      restrictList.includes("oc5") ||
      restrictList.includes("ocd") ||
      restrictList.includes("oc5m") ||
      restrictList.includes("ocb");
    if (!suppressHint) baseMsg += " (" + allowedList + ").";
    else baseMsg += ".";

    var w = new QAlert();
    w.InitAlert(appstr("Invalid File Type"), baseMsg, null, this.fWSMgr);
  }

  DoMissingFileWarning() {
    var w = new QAlert();
    w.InitAlert(appstr("Alert"), appstr("filenotfound"), null, this.fWSMgr);
  }

  GetSaveScope() {
    // TODO add other save scope options (chart / branch / etc);
    return enumFileMgrMode.savemaster ? enumSaveScope.background : enumSaveScope.entireChart;
    //return this.fFileNamePanel.GetSaveScope();
  }

  OKToOpenFile() {
    var okToProceed = true;
    var fileExists = this.FileExistsInCurDirectory(this.GetCurrentFileName());
    var validExtSelected = this.ValidExtension();
    if (!validExtSelected) {
      okToProceed = false;
      this.InvalidFileSelectedAlert();
    }
    if (!fileExists) {
      okToProceed = false;
      this.DoMissingFileWarning();
    }

    return okToProceed;
  }

  IsOriginalFile(dirName, fileName) {
    if (this.fOriginalName == null || this.fOriginalDir == null) return false;

    if (
      dirName.toLowerCase() == this.fOriginalDir.toLowerCase() &&
      fileName.toLowerCase() == this.fOriginalName.toLowerCase()
    )
      return true;
    else return false;
  }

  DoSaveFile() {
    var cFolder = this.GetCurrentFolder();
    if (this.LockedMsg(cFolder, "filelocked")) return;

    var okToProceed = true;
    var curFile = this.GetCurrentFile();

    if (!curFile || (curFile && curFile.length === 0)) return false;

    if (!ValidateRename(curFile, this.fWSMgr).valid) return false;

    var fileName = this.GetCurrentFileName();
    var fileExists = this.FileExistsInCurDirectory(fileName);
    if (fileExists) {
      var originalFile = this.IsOriginalFile(this.GetCurrentFolderName(), fileName);
      if (!originalFile) {
        okToProceed = false;
        var w = new QAlert();
        w.InitOKAlert(
          appstr("Alert"),
          appstr("replacemsg"),
          this,
          this.fWSMgr,
          "OKSaveFile",
          "CnclSaveFile"
        );
      }
    }

    return okToProceed;
  }

  ExecuteAlertCommand(aCmd) {
    var theCode = aCmd.GetCmdCode();
    var handled = true;

    switch (theCode) {
      case "CnclSaveFile": // Nothing to do...
      case "CnclDeleteFile":
        break;
      case "OKSaveFile": // From Warning dialog (replace exists save it anyway)
        this.fWSMgr.CompleteSave(true);
        break;
      case "OKDeleteAllFiles":
        this.DoDeleteSelectedFiles(true);
        break;
      case "OKDeleteFile":
        this.DoDeleteSelectedFiles(false);
        break;
      default:
        handled = false;
        break;
    }
    return handled;
  }

  GetFileModificationDate(date) {
    var oi = this.fWSMgr.GetOrgInfo();
    var dateFormat = oi.GetDateFormat();
    var timeFormat = oi.GetTimeFormat();

    var dateTime = date.split(",");
    var dateString = dateTime[0];
    var timeString = dateTime[1];

    var d1 = new Date();
    var formatTime = d1.convertUTCDateToLocalDateString(
      dateString,
      timeString,
      timeFormat,
      enumDateTimeDisplayOptions.time
    );
    var formatDate = d1.FormatDate(dateFormat);

    var localModDateString = formatDate + ", " + formatTime;

    return localModDateString;
  }

  GetPermissions(role) {
    return this.userRoles[role];
  }
}
